import React from 'react';

export default function ViewQuestionsModal({ test, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-1 flex items-center gap-2">
              <span className="text-3xl">❓</span>
              Test Questions
            </h2>
            <p className="text-gray-600">{test.title}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
          >
            ×
          </button>
        </div>

        {!test.questions || test.questions.length === 0 ? (
          <div className="text-center py-8 bg-gray-50 rounded-lg">
            <p className="text-gray-500">No questions added to this test</p>
          </div>
        ) : (
          <div className="space-y-4">
            {test.questions.map((question, index) => (
              <div
                key={question.id || index}
                className="bg-gradient-to-r from-indigo-50 to-purple-50 border-2 border-indigo-200 rounded-lg p-5"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="bg-indigo-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg">
                      {index + 1}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="mb-2">
                      <span className="text-xs font-semibold text-indigo-700">Question {index + 1}</span>
                    </div>
                    <div
                      className="text-gray-900 leading-relaxed prose max-w-none"
                      dangerouslySetInnerHTML={{ __html: question.question_text }}
                    />
                    {question.attachment_url && (
                      <div className="mt-3">
                        <a
                          href={question.attachment_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-indigo-600 hover:text-indigo-800 text-sm font-semibold flex items-center gap-2"
                        >
                          <span>📎</span>
                          View Attachment
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-6 pt-4 border-t border-gray-200 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

